// Centralized project data - SHARED VERSION (for both main and latest)
// This file contains basic project information for display on home page

// Import logo images
import remoteIcon from '../images/icons/RemoteIcon.webp';
import secondNatureIcon from '../images/icons/SNIcon.webp';

import remoteAgentTheme from '../projects/remote-agent/imgs/theme.webp'
import automationsTheme from '../projects/automations/imgs/theme.webp'
import medsTheme from '../projects/weight-loss-medication/imgs/theme.webp'
import medsHero from '../projects/weight-loss-medication/imgs/meds-hero.webp'
import globezonesTheme from '../projects/globezones/imgs/theme.webp'
import icantcopeTheme from '../projects/icantcope/imgs/theme.webp'
import observeTheme from '../projects/observe/imgs/theme.webp'

import remoteAgentHero1 from '../projects/remote-agent/imgs/AgentHero.webp'
import automationsHero1 from '../projects/automations/imgs/AutomationsHero1.webp'
import medsHero1 from '../projects/weight-loss-medication/imgs/MedsHero1.webp'
import medsHero2 from '../projects/weight-loss-medication/imgs/MedsHero2.webp'
import globezonesHero1 from '../projects/globezones/imgs/GlobezonesHero1.webp'
import globezonesHero2 from '../projects/globezones/imgs/GlobezonesHero2.webp'
import icantcopeHero from '../projects/icantcope/imgs/ICantCopeHero.webp'
import observeHero1 from '../projects/observe/imgs/ObserveHero1.webp'
import observeHero2 from '../projects/observe/imgs/ObserveHero2.webp'
import cmdgitHero1 from '../projects/cmdgit/imgs/cmdgit-1.png'
import cmdgitHero2 from '../projects/cmdgit/imgs/cmdgit-2.jpeg'

// Company information
export const companies = {
    remote: {
        name: 'Remote.com',
        period: '2024 – Now',
        logo: remoteIcon,
        otherStuff: [
            { title: 'Led Design org transition to AI-builders.', body: 'Support and docs for everyone to ship to production.' },
            { title: 'Best UX – Hackathon winning team.', body: 'Initial concept for an omnipresent Agent.' },
            { title: '2x Award Nominee – Innovation.', body: 'For continuous work on Agent & AI.' },
            { title: 'Supported 4+ teams in 18 months.', body: 'Recruit, Knowledge Management, Automations and AI.' }
        ]
    },
    secondNature: {
        name: 'Second Nature',
        period: '2021 – 2024',
        logo: secondNatureIcon,
        otherStuff: [
            { title: 'Churn 40% down on consumer product.', body: 'Learned about user blockers and deployed solutions.' },
            { title: '0 to 800+ users in 4 months.', body: 'Research and Design for a new NHS product.' },
            { title: 'Helped people change their lives.', body: 'Helped people lose weight and reverse diabetes.' },
            { title: 'Parity between design and code.', body: 'Worked closely with Engineering to achieve parity in our work.' },
        ]
    },
    other: {
        name: '✿ Other projects',
        period: '∞',
        logo: null,
        otherStuff: []
    }
};

// Project summaries for home page display (shared between main and latest)
export const projectSummaries = {
    'remote-agent': {
        title: 'Remote Agent',
        description: 'Led the design vision for Remote Agent from 1-week hackathon prototype to launch.',
        company: 'remote',
        period: 'Oct 2024 – Now',
        slug: 'remote-agent',
        hasImages: false,
        media: [{ theme: remoteAgentTheme, span: 'full', src: remoteAgentHero1 }],
        tags: ['Product Design', 'AI Design', 'Agents']
    },
    'automations': {
        title: 'Automations',
        description: 'Designed a canvas-based interaction model that became the new pattern for how to build scalable workflows at Remote.',
        company: 'remote',
        period: 'Oct 2024 – Now',
        slug: 'automations',
        hasImages: true,
        imageLayout: 'two-column',
        media: [{ theme: automationsTheme, span: 'full', src: automationsHero1 }],
        tags: ['Product Design', 'Automations', 'Workflows', 'AI', 'Collaboration with other teams']
    },
    // 'ai-vision': {
    //     title: 'AI vision',
    //     description: 'Leading the design of Remote AI across multiple products, defining the guidelines for AI-powered experiences at Remote.',
    //     company: 'remote',
    //     period: 'Oct 2024 – Now',
    //     slug: 'ai-vision',
    //     hasImages: true,
    //     imageLayout: 'two-column',
    //     tags: ['Product Design', 'AI Design', 'Brand Guidelines', 'Scalibility', 'Collaboration with other teams']
    // },
    // 'ai-interviews': {
    //     title: 'AI interviews',
    //     description: 'Designed a tool to help candidates practice interviews with an AI interviewer and build their profile for recruiters.',
    //     company: 'remote',
    //     period: 'Oct 2024 – Now',
    //     slug: 'ai-interviews',
    //     hasImages: false,
    //     tags: ['Product Design', 'AI Design', 'Collaboration with domain experts', 'Collaboration with 3rd party vendors']
    // },
    'meds': {
        title: 'Weight-loss medication management',
        description: 'Designed a visual system to help users track their medication from warehouse to their home.',
        company: 'secondNature',
        period: '2021 – 2024',
        slug: 'meds',
        hasImages: true,
        media: [
            { theme: medsTheme, span: 'half', src: medsHero1, padding: "1 1 0 1", align: 'end' },
            { theme: medsTheme, span: 'half', src: medsHero2, padding: "0 1 0 1"},
        ],
        tags: ['Mobile', 'Healthcare', 'Medication Management', 'Illustrations']
    },
    // 'b2b-engagement': {
    //     title: 'Launched a new NHS weight-loss programme',
    //     description: 'Helped uncover a new market segment and designed a personalized weight-loss programme.',
    //     company: 'secondNature',
    //     period: '2021 – 2024',
    //     slug: 'b2b-engagement',
    //     hasImages: true,
    //     tags: ['B2B', 'Activation', '0-1', 'Research', 'Growth and market segmentation']
    // },
    'globezones': {
        title: 'Globezones',
        description: 'Built an iOS app to manage friends, family, and colleague\'s timezones across the world.',
        company: 'other',
        period: '∞',
        externalLink: 'https://globezones.com',
        media: [
            { theme: globezonesTheme, span: 'half', src: globezonesHero1, padding: '0', shadow: 'off' },
            { theme: globezonesTheme, span: 'half', src: globezonesHero2, padding: '1 1 1 1', shadow: 'off' },
        ],
        tags: ['iOS App', 'Timezone Management', 'Personal Project']
    },
    'observe': {
        title: 'Observe',
        description: 'Built an Apple Watch meditation app with vibration-guided sessions in three phases.',
        company: 'other',
        period: '∞',
        externalLink: 'https://observe.gvns.xyz',
        media: [
            { theme: observeTheme, span: 'half', src: observeHero2, padding: '0 1 0 1', shadow: 'off', maxWidth: 200 },
            { theme: observeTheme, span: 'half', src: observeHero1, padding: '0 1 0 1', shadow: 'off', maxWidth: 200 },
        ],
        tags: ['Apple Watch', 'Meditation', 'Personal Project']
    },
    'cmdgit': {
        title: 'cmdgit',
        description: 'Mac app overlay based on shortcuts, for those who still enjoy writing commits from time to time, but fast.',
        company: 'other',
        period: '∞',
        externalLink: 'https://x.com/gvns0x/status/2113712735397740702',
        media: [
            { span: 'half', src: cmdgitHero1, padding: '0 0 0 0', shadow: 'off'  },
            { span: 'half', src: cmdgitHero2, padding: '0 0 0 0', shadow: 'off' },
        ],
        tags: ['Mac App', 'Personal Project']
    },
    'icantcope': {
        title: 'icantcope',
        description: 'Art project with prototyping software to explore how we deal with emotions using technology.',
        company: 'other',
        period: '∞',
        externalLink: 'https://icantcope.gvns.xyz',
        media: [{ theme: icantcopeTheme, span: 'full', src: icantcopeHero, padding: '1 1 1 1' }],
        tags: ['Art Project', 'Emotional Design', 'Prototyping']
    }
};

// Helper functions that work with summaries only
export const getProjectSummaries = () => Object.values(projectSummaries);

export const getProjectSummaryBySlug = (slug) => {
    return Object.values(projectSummaries).find(project => project.slug === slug);
};

// Helper function to get project summaries by company
export const getProjectSummariesByCompany = (companyKey) => {
    return Object.values(projectSummaries).filter(project => project.company === companyKey);
};

// Helper function to get project order from summaries
export const getProjectSummaryOrder = () => {
    return Object.values(projectSummaries).map(project => project.slug);
};
